<dw-ui-panel [defaultOpenedPanel]="infoPanel()" [triggers]="triggers()">
  <dw-grid-detail-navigation
    header-actions
    [context]="GoliathDocumentEntityNames.InventoryCountDoc.shortName"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-2 mt-2 header">
                    <!-- Bloc 1 : Site / Responsable / Date -->
                    <div class="card p-2 border">
                      <div>
                        <label for="companySiteId" class="form-label text-primary" dwInputRequired>
                          {{ '::Site' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="companySiteId"
                          bindLabel="code"
                          bindValue="id"
                          formControlName="companySiteId"
                          [loading]="companySiteStore.loading()"
                          [items]="companySiteStore.entities()"
                        >
                        </ng-select>
                      </div>
                      <div>
                        <label for="responsibleId" class="form-label text-primary" dwInputRequired>
                          {{ '::Responsible' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="responsibleId"
                          bindLabel="code"
                          bindValue="id"
                          formControlName="responsibleId"
                          [loading]="salesPersonStore.loading()"
                          [items]="salesPersonStore.entities()"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            @if (item != null) {
                              {{ item.lastName }} {{ item.firstName }}
                            }
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <span [title]="item.firstName + ' ' + item.lastName"
                              >{{ item.lastName }} {{ item.firstName }}</span
                            >
                          </ng-template>
                        </ng-select>
                      </div>
                      <div>
                        <label for="inventoryDate" class="form-label text-primary" dwInputRequired>
                          {{ 'Doc::InventoryCount:Date' | abpLocalization }}
                        </label>
                        <dw-core-date-picker
                          formControlName="inventoryDate"
                          [minDate]="minInventoryDate"
                        ></dw-core-date-picker>
                      </div>
                    </div>

                    <!-- Bloc 2 : Entrepôt / Emplacement(s) / Description -->
                    <div class="card p-2 border">
                      <div>
                        <label for="warehouseId" class="form-label text-primary">
                          {{ 'Doc::StockDoc:Warehouse' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="warehouseId"
                          #warehouseApiSelect="dwApiSelect"
                          bindValue="id"
                          bindLabel="code"
                          formControlName="warehouseId"
                          [dwApiSelect]="warehouseSelect"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            {{ item.code }}
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <span [title]="item.name">{{ item.code }} - {{ item.name }}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div>
                        <label
                          for="storageLocationIds"
                          class="form-label text-primary"
                          dwInputRequired
                        >
                          {{ 'Doc::InventoryCount:StorageLocations' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="storageLocationIds"
                          #storageLocationApiSelect="dwApiSelect"
                          bindValue="id"
                          bindLabel="code"
                          formControlName="storageLocationIds"
                          [multiple]="true"
                          [closeOnSelect]="false"
                          [clearSearchOnAdd]="true"
                          [dwApiSelect]="storageLocationSelect"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            {{ item.code }}
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <span [title]="item.name">{{ item.code }} - {{ item.name }}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div>
                        <label for="description" class="form-label text-primary">
                          {{ '::Description' | abpLocalization }}
                        </label>
                        <input type="text" class="form-control" formControlName="description" />
                      </div>
                    </div>

                    <!-- Bloc 3 : Statut / Priorité / Opérateur Assigné -->
                    <div class="card p-2 border">
                      <div>
                        <label for="status" class="form-label text-primary">
                          {{ 'Doc::InventoryCount:Status' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="status"
                          formControlName="status"
                          bindLabel="name.current"
                          bindValue="id"
                          [loading]="enumerationTypeStoreDoc.loading()"
                          [items]="selectableStatuses()"
                        >
                        </ng-select>
                      </div>
                      <div>
                        <label for="priority" class="form-label text-primary" dwInputRequired>
                          {{ 'Doc::InventoryCount:Priority' | abpLocalization }}
                        </label>
                        <input
                          type="number"
                          min="1"
                          max="9"
                          step="1"
                          class="form-control"
                          formControlName="priority"
                        />
                      </div>
                      <div>
                        <label for="workerId" class="form-label text-primary">
                          {{ 'Doc::InventoryCount:AssignedOperator' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="workerId"
                          bindLabel="code"
                          bindValue="id"
                          formControlName="workerId"
                          [dwApiSelect]="workerSelect"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            @if (item != null) {
                              {{ item.lastName }} {{ item.firstName }}
                            }
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <span [title]="item.firstName + ' ' + item.lastName"
                              >{{ item.lastName }} {{ item.firstName }}</span
                            >
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div>
                    @if (entity?.id != null) {
                      <document-inventory-count-doc-lines-grid
                        [document]="entity"
                        (lineUpdated)="onLineUpdated($event)"
                      >
                      </document-inventory-count-doc-lines-grid>
                    }
                  </div>
                </form>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <button
        (click)="save()"
        class="btn btn-primary ms-2"
        form="generalForm"
        async
        [isBusy]="isSaving()"
        [disabled]="(!form.dirty && !noteDirty()) || isSaving()"
      >
        {{ '::Save' | abpLocalization }}
      </button>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyInfo">
      <ng-template #bodyInfo>
        <div class="aside-body">
          <div class="audit-container mb-3">
            <core-informations-audited-entity [auditedEntity]="entity">
            </core-informations-audited-entity>
          </div>
        </div>
        <label for="note" class="form-label text-primary mt-3">{{
          'GoliathCore::Note' | abpLocalization
        }}</label>
        @if (entity != null) {
          <textarea
            name="note"
            class="flex-grow-1"
            resize="none"
            [(ngModel)]="entity.note"
            (ngModelChange)="onNoteChanged()"
          ></textarea>
        }
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel #history [contentTemplate]="bodyHistory">
      <ng-template #bodyHistory>
        <div class="history__container">
          <dw-core-history
            [entityId]="entity?.id"
            entityName="Digiwall.GoliathDocuments.InventoryCountDocs.InventoryCountDoc"
          ></dw-core-history>
        </div>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.InventoryCountDoc.shortName"
          [entityReference]="entity?.id"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>
